// Header
import Header from './header';

// News Tabs
import NewsTabs from './news-tabs';

// Parts Search Bar
import SearchBar from './d-search-bar';

// Where to buy app
import WhereToBuy from './where-to-buy';

// Language Switch
import LanguageSwitch from './lang-switch';

// Article Item
import ArticleItem from './article-item';

// Video Popup
import VideoPopup from './video-list';

// Video Popup
import SectionCatcher from './section-catcher';

// More Product Block
import MoreBlock from './more-block';

// Accordion
import Accordion from './accordion';

// Denso Filter
import DensoFilter from './denso-filter';

// Innovations timeline
import Innovations from './innovations';

// Visit Role Drop Down
import VisitRole from './visit-role';

// Back To Top Button
import BackToTop from './back-to-top';

// Find My Part
import FindMyPart from './denso-catalog';

// Team
import Team from './team';

// Cookie Bar
import CookieBar from './cookie-bar';

// Contact
import Contact from './contact';

// Locations
import Locations from './locations';

// Downloads
import Downloads from './downloads';

// Auth
import Auth from './auth';

// User Account
import UserAccount from './user-account';

// Denso Slider
import DensoSlider from './denso-slider';

// Sticky Sidebar
import PartSidebar from './part-sidebar';

// Mobile Menu
import MobileMenu from './mobile-menu';

// Sentry
import SentryLog from './sentry';

// Navigation for Find your automotive parts
import Navigation from './navigation';

// Where to buy on home page
import RepairStation from './repair-station';

// Global search
import GlobalSearch from './denso-global-search';

// Simple Page
import SimplePage from './simple-page';

// About video
import About from './about';

// Partners Block
import PartnersSlider from './partners-block';

export default [
  Header,
  NewsTabs,
  SearchBar,
  WhereToBuy,
  LanguageSwitch,
  VideoPopup,
  SectionCatcher,
  MoreBlock,
  Innovations,
  Accordion,
  DensoFilter,
  VisitRole,
  BackToTop,
  FindMyPart,
  Team,
  CookieBar,
  ArticleItem,
  Contact,
  Locations,
  Downloads,
  Auth,
  UserAccount,
  DensoSlider,
  PartSidebar,
  MobileMenu,
  SentryLog,
  Navigation,
  RepairStation,
  GlobalSearch,
  SimplePage,
  About,
  PartnersSlider,
];
